'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _actions = require('../../../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _linksoftAlbatros = require('linksoft-albatros');

var _StepBase = require('../StepBase');

var _StepBase2 = _interopRequireDefault(_StepBase);

var _FixStepButton = require('../FixStepButton');

var _FixStepButton2 = _interopRequireDefault(_FixStepButton);

var _MessageWarning = require('../MessageWarning');

var _MessageWarning2 = _interopRequireDefault(_MessageWarning);

var _CartDetailItem = require('./CartDetailItem');

var _CartDetailItem2 = _interopRequireDefault(_CartDetailItem);

var _DiscountCoupon = require('./DiscountCoupon');

var _DiscountCoupon2 = _interopRequireDefault(_DiscountCoupon);

var _Voucher = require('./Voucher');

var _Voucher2 = _interopRequireDefault(_Voucher);

var _DiscountCouponForm = require('./DiscountCouponForm');

var _DiscountCouponForm2 = _interopRequireDefault(_DiscountCouponForm);

var _DispatchWarning = require('../DispatchWarning');

var _DispatchWarning2 = _interopRequireDefault(_DispatchWarning);

var _FreeProducts = require('./FreeProducts');

var _FreeProducts2 = _interopRequireDefault(_FreeProducts);

var _sticky = require('linksoft-albatros/src/components/sticky');

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _FreeProductItem = require('./FreeProductItem');

var _FreeProductItem2 = _interopRequireDefault(_FreeProductItem);

var _GiftItem = require('./GiftItem');

var _GiftItem2 = _interopRequireDefault(_GiftItem);

var _storageProvider = require('../../../../storageProvider');

var _storageProvider2 = _interopRequireDefault(_storageProvider);

var _analyticsPusherLibrary = require('../../../../analyticsPusherLibrary');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

function mapStateToProps(state) {
    var options = (0, _linksoftAlbatros.getCartOptions)(state.cart);
    var selectedProductIds = !options.selectedFreeProducts ? [] : options.selectedFreeProducts.map(function (p) {
        return p.discountCampaignFreeProductId;
    }) || [];

    return {
        cart: state.cart,
        items: state.cart.items || [],
        giftItems: state.cart.giftItems || [],
        freeProducts: state.cart.freeProducts || [],
        totalPrice: state.cart.totalPrice || {},
        coupon: state.cart.coupon,
        voucher: state.cart.voucher,
        selectedFreeProductIds: selectedProductIds,
        showFreeProductWarning: state.cart.freeProducts.length > selectedProductIds.length,
        processing: !!(state.cart.processing || (0, _keys2.default)(state.cart.changes).length || (0, _keys2.default)(state.cart.changedOptions).length || state.cart.settingCoupon),
        couponRefusedReason: state.cart.couponRefusedReason
    };
}

var mapDispatchToProps = {
    saveOptions: _actions2.default.saveOptions,
    setStep: _actions2.default.setStep,
    updateFreeProducts: _actions2.default.updateFreeProducts
};

var CartDetailStep1 = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_CartDetailStepBase) {
    (0, _inherits3.default)(CartDetailStep1, _CartDetailStepBase);

    function CartDetailStep1(props) {
        (0, _classCallCheck3.default)(this, CartDetailStep1);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CartDetailStep1.__proto__ || (0, _getPrototypeOf2.default)(CartDetailStep1)).call(this, props, 1));

        _this.freeProductSelected = function (e) {
            _this.props.updateFreeProducts(e.selectedId, e.unselectedId);
        };

        _this.state = { maxWidth: 9999, paddingRight: 40 };
        _analyticsPusherLibrary.analyticsPusherLibrary.pushCheckout(_this.step, _this.props.cart).then(function () {});
        return _this;
    }

    (0, _createClass3.default)(CartDetailStep1, [{
        key: 'updateWidthForAnimation',
        value: function updateWidthForAnimation() {
            var _this2 = this;

            setTimeout(function () {
                if (!(0, _linksoftAlbatros.isMaxWidth)('xs')) {
                    // reset
                    if (_this2.state.maxWidth !== _this2._cartItems.offsetWidth) {
                        _this2.setState({ maxWidth: _this2._cartItems.offsetWidth });
                    }
                }
            }, 100);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            _storageProvider2.default.clearValueSession(_storageProvider2.default.cartCacheKey);
            this.updateWidthForAnimation();
            window.addEventListener("resize", this.updateWidthForAnimation.bind(this));
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.cart.step === prevProps.cart.step) return;

            if (this.isPreviousUpdated(prevProps)) {
                // right padding for items
                this.setState({ paddingRight: 0 });
            } else {
                this.setState({ paddingRight: 40, maxWidth: 9999 });
            }
        }
    }, {
        key: 'nextStep',
        value: function nextStep() {
            var _this3 = this;

            if (this.props.processing) return;
            setTimeout(function () {
                var _props = _this3.props,
                    showFreeProductWarning = _props.showFreeProductWarning,
                    voucher = _props.voucher,
                    processing = _props.processing;

                if (processing) return;
                var voucherRemainingPrice = voucher ? voucher.info.nominalValue - voucher.info.appliedValue : 0;
                var alerts = [];
                var alertHandler = function alertHandler(stay) {
                    if (!stay) {
                        if (alerts.length > 0) {
                            setTimeout(alerts.pop(), 50);
                        } else {
                            (0, _get3.default)(CartDetailStep1.prototype.__proto__ || (0, _getPrototypeOf2.default)(CartDetailStep1.prototype), 'nextStep', _this3).call(_this3);
                        }
                    }
                };
                if (showFreeProductWarning) {
                    alerts.push(function () {
                        return sweetAlert({
                            text: Resx.App.FreeProductNotSelectedWarning,
                            type: 'warning',
                            title: Resx.App.FreeProduct,
                            showCancelButton: true,
                            cancelButtonText: Resx.App.DontWantFreeProduct,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: Resx.App.WantChooseFreeProduct
                        }, function (val) {
                            alertHandler(val);
                        });
                    });
                }
                if (voucherRemainingPrice > 0) {
                    alerts.push(function () {
                        return sweetAlert({
                            text: Resx.App.RemainingVoucherValueWarning.replace("{0}", (0, _linksoftAlbatros.formatPrice)(voucherRemainingPrice, _linksoftAlbatros.PriceType.CartTotalPrice)),
                            type: 'warning',
                            title: Resx.App.RemainingVoucherValueWarningTitle,
                            showCancelButton: true,
                            cancelButtonText: Resx.App.ContinueAnyway,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: Resx.App.BackToCart
                        }, function (val) {
                            alertHandler(val);
                        });
                    });
                }
                if (alerts.length > 0) {
                    setTimeout(alerts.pop(), 50);
                } else {
                    (0, _get3.default)(CartDetailStep1.prototype.__proto__ || (0, _getPrototypeOf2.default)(CartDetailStep1.prototype), 'nextStep', _this3).call(_this3);
                }
            }, 500);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props2 = this.props,
                items = _props2.items,
                giftItems = _props2.giftItems,
                freeProducts = _props2.freeProducts,
                totalPrice = _props2.totalPrice,
                coupon = _props2.coupon,
                voucher = _props2.voucher,
                selectedFreeProductIds = _props2.selectedFreeProductIds,
                showFreeProductWarning = _props2.showFreeProductWarning,
                processing = _props2.processing,
                couponRefusedReason = _props2.couponRefusedReason;

            var showSubmitButton = items.length > 0 || giftItems.length > 0;
            var freeDeliveryMessage = this.freeDelivery();
            var possibleFreeDeliveryMessage = this.possibleFreeDelivery();
            var freeProductMessage = this.freeProducts();
            var ultraTotalPrice = Math.max(totalPrice.finalPrice - (voucher ? voucher.info.appliedValue : 0), 0);
            var itemsStyle = {
                maxWidth: this.state.maxWidth,
                paddingRight: this.state.paddingRight || 0
            };

            var allProducts = freeProducts.reduce(function (ar, campaign) {
                return ar.concat(campaign.freeProducts);
            }, []);

            var selectedFreeProducts = allProducts.reduce(function (selected, item) {
                if (selectedFreeProductIds.indexOf(item.id) >= 0) {
                    selected.push(item);
                }
                return selected;
            }, []);

            var nextStepClass = 'btn btn--xl btn--green';
            if (processing) nextStepClass += ' btn--inactive';

            return _react2.default.createElement(
                'div',
                { className: this.stepClass() },
                _react2.default.createElement(
                    'h3',
                    { className: 'cart__section-title' },
                    Resx.App.SelectedProducts
                ),
                _react2.default.createElement(
                    'div',
                    { ref: function ref(el) {
                            return _this4._cartItems = el;
                        }, className: 'cart__items', style: itemsStyle },
                    _react2.default.createElement(
                        'div',
                        { className: 'cart__items-header' },
                        _react2.default.createElement(
                            'div',
                            null,
                            Resx.Common.Title,
                            ', ',
                            Resx.Common.Author.toLowerCase(),
                            _react2.default.createElement('br', null),
                            ' ',
                            Resx.App.PricePerPiece
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'justify-content-end text-right pl-2' },
                            Resx.App.Amount
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'justify-content-end text-right pl-2' },
                            Resx.App.TotalPriceWithVat
                        )
                    ),
                    items.map(function (item) {
                        return _react2.default.createElement(_CartDetailItem2.default, (0, _extends3.default)({}, item, { key: item.id }));
                    }),
                    selectedFreeProducts.map(function (item) {
                        return _react2.default.createElement(_FreeProductItem2.default, (0, _extends3.default)({}, item, { key: item.id }));
                    }),
                    giftItems.length > 0 && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'h2',
                            { className: 'cart-items__title' },
                            Resx.App.Gifts,
                            ' ',
                            _react2.default.createElement(
                                'a',
                                { className: 'small',
                                    href: '/Gift' },
                                '(',
                                Resx.App.GiftCatalog,
                                ')'
                            )
                        ),
                        giftItems.map(function (item) {
                            return _react2.default.createElement(_GiftItem2.default, (0, _extends3.default)({}, item, { key: item.giftId }));
                        })
                    ),
                    (coupon || couponRefusedReason) && _react2.default.createElement(_DiscountCoupon2.default, (0, _extends3.default)({}, coupon, { refuseReason: couponRefusedReason })),
                    voucher && _react2.default.createElement(_Voucher2.default, voucher),
                    _react2.default.createElement(
                        'div',
                        { className: 'cart__item cart__item--last' },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'strong',
                                { className: 'title h4' },
                                Resx.Common.Total
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'cart-i__summary' },
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    (0, _linksoftAlbatros.formatPrice)(ultraTotalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                                )
                            )
                        )
                    ),
                    this.isActive() && showFreeProductWarning && _react2.default.createElement(
                        'div',
                        { className: 'warning warning--sm' },
                        _react2.default.createElement(
                            'span',
                            { className: 'warning__message' },
                            Resx.App.FreeProductNotSelectedWarning
                        )
                    ),
                    _react2.default.createElement(_FixStepButton2.default, { text: Resx.App.FixTheCart, onClick: function onClick() {
                            return _this4.goToStep();
                        } })
                ),
                _react2.default.createElement(
                    _sticky.StickyContainer,
                    { className: this.asideClass() },
                    _react2.default.createElement(
                        _sticky.Sticky,
                        { disableCompensation: !!(0, _linksoftAlbatros.isMaxWidth)('sm') },
                        function (_ref) {
                            var style = _ref.style;
                            return _react2.default.createElement(
                                'div',
                                { style: !(0, _linksoftAlbatros.isMaxWidth)('sm') ? (0, _extends3.default)({}, style, { paddingTop: 20 }) : {} },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    !!freeDeliveryMessage.text && _react2.default.createElement(_MessageWarning2.default, { icon: 'icon--van', text: freeDeliveryMessage.text }),
                                    !!possibleFreeDeliveryMessage.text && _react2.default.createElement(_MessageWarning2.default, { icon: 'icon--van', text: possibleFreeDeliveryMessage.text }),
                                    !!freeProductMessage.text && _react2.default.createElement(_MessageWarning2.default, { icon: 'icon--gift', text: freeProductMessage.text }),
                                    _react2.default.createElement(_DiscountCouponForm2.default, coupon),
                                    freeProductMessage.active && _react2.default.createElement(_FreeProducts2.default, {
                                        products: freeProducts,
                                        selectedIds: selectedFreeProductIds,
                                        onChange: _this4.freeProductSelected }),
                                    _react2.default.createElement(_DispatchWarning2.default, null),
                                    showSubmitButton && _react2.default.createElement(
                                        'div',
                                        { className: 'cart__submit' },
                                        _react2.default.createElement(
                                            'button',
                                            { id: 'cartStep1Submit', className: nextStepClass,
                                                onClick: function onClick() {
                                                    return _this4.nextStep();
                                                } },
                                            Resx.App.TransportationAndPaymentTitle,
                                            _react2.default.createElement('i', { className: 'icon--arrow-right' })
                                        )
                                    )
                                )
                            );
                        }
                    )
                )
            );
        }
    }]);
    return CartDetailStep1;
}(_StepBase2.default), _class2.propTypes = {
    items: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    giftItems: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    freeProducts: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    totalPrice: _propTypes2.default.object.isRequired,
    coupon: _propTypes2.default.object,
    voucher: _propTypes2.default.object,
    selectedFreeProductIds: _propTypes2.default.arrayOf(_propTypes2.default.number),
    showFreeProductWarning: _propTypes2.default.bool.isRequired,
    processing: _propTypes2.default.bool,

    empty: _propTypes2.default.func.isRequired,
    setStep: _propTypes2.default.func.isRequired,
    updateFreeProducts: _propTypes2.default.func.isRequired,
    couponRefusedReason: _propTypes2.default.object
}, _temp)) || _class);
exports.default = CartDetailStep1;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step1/Step1.js
// module id = 1022
// module chunks = 0